import {
  CommercialListControlAction,
  CommercialListMultiplierAction,
} from '../state/commercial-list.model';

export function isMultiplierAction(
  action: CommercialListControlAction,
): action is CommercialListMultiplierAction {
  return action.type === 'multiplier';
}
